<mat-card [class.active]="active" [style.border]="border" appearance="outlined" class="checkedItem">
    <div *ngIf="selectionVisible" class="inputcontainer">
        <input (click)="selectItem()" [(ngModel)]="selected" [hidden]="active" type="checkbox" />
    </div>
    <div class="checked-content">
        <div (click)="activeItem()" class="checked-label">
            <label *ngIf="title" [title]="title" class="title">{{ title }}</label>
            <label *ngIf="description" [title]="description" class="description">{{ description }}</label>
        </div>
        <div *ngIf="!title && !description">
            <ng-content></ng-content>
        </div>
    </div>
</mat-card>
